import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"

export default {
    bookingProcessURL: (state, getters) => {
        const beginDateParts = state.dates["BeginDate"] && state.dates["BeginDate"].split("/")
        const endDateParts = state.dates["EndDate"] && state.dates["EndDate"].split("/")

        const liheId = getters.selectedPrestations[0].prestation.fusionId || state.liheData.id;
        const participants = state.participants.join("-");
        const start_date = beginDateParts ? `${beginDateParts[2]}-${beginDateParts[1]}-${beginDateParts[0]}` : "";
        const end_date = endDateParts ? `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}` : "";
        const prestId = getters.selectedPrestations[0].prestation.prestId
        const prestations = getters.selectedPrestations && getters.selectedPrestations.map((prest)=>{
            return `${prest.prestation.prestIdSource}-${prest.quantity}-${prest.prestation.maxCapacity}`
        }).filter(_=>_).join('--');
        const season = global.seasonManager.season ? global.seasonManager.season : "";



        const pagePath = getBookingPocessPath(state, getters.locale)

        let baseUrl = window.location.hostname === 'localhost' 
            ? `http://${process.env.VUE_APP_DEFAULT_DOMAIN}/booking/${pagePath}?lihe_id=${liheId}&participants=${participants}&start_date=${start_date}&end_date=${end_date}&prestations=${prestations}&season=${season}&prest_id=${prestId}`
            : `/booking/${pagePath}?lihe_id=${liheId}&participants=${participants}&start_date=${start_date}&end_date=${end_date}&prestations=${prestations}&season=${season}&prest_id=${prestId}`

        // Add the origin to the url
        if (state.flightOrigin && (flightPackCode.includes(state.packCode) || trainPackCode.includes(state.packCode))) {
            baseUrl += `&origin=${state.flightOrigin.split("-")[0]}`
        }

        return baseUrl 
    }
}


function getBookingPocessPath(state, locale) {

    if (flightPackCode.includes(state.packCode)) {
        return "flight"
    }
    else if (trainPackCode.includes(state.packCode)) {
        return "train"
    }
    return "options";
}